<div class="dashboard-wrapper">
  @if (selectedTicket || mode === 'create') {
    <div class="workflow-background"></div>
  }
  <div class="v-card">

    <div class="card list-header list-header-fixed flex-row justify-content-between align-items-center pe-4 ps-4">
      <div class="d-flex">
        <div class="header fs-20 font-weight-700 pt-1 me-2">{{ 'MAIN.CONTENT.TICKETS.TITLE' | translate }}</div>
      </div>

      <div>
        <div class="d-flex flex-column">
          <button class="v-btn btn btn-primary vsight-button create-button" (click)="onCreateTicket()">{{ 'MAIN.CONTENT.TICKETS.NEW_TICKET' | translate }}</button>
        </div>
      </div>
    </div>

    @if (!isLoading) {
      <div class="tickets">
        <div class="card tab-area d-flex flex-row">
          <div class="tab-item left fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 0 }" (click)="onTabClicked(0)">
            <span class="tab-title">
              {{ 'MAIN.CONTENT.TICKETS.TAB_ACTIVE' | translate }}
            </span>
          </div>
          <div class="tab-item right fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 1 }" (click)="onTabClicked(1)">
            <span class="tab-title">
              {{ 'MAIN.CONTENT.TICKETS.TAB_CLOSED' | translate }}
            </span>
          </div>
        </div>
        <div class="card list-area">
          <div class="filter-area">
            <div class="row">
              <div class="col-3 mt-2">
                <ng-select [items]="rooms" name="rooms" bindLabel="name" bindValue="id" [clearSearchOnAdd]="true" [closeOnSelect]="false"
                  placeholder="{{ 'MAIN.CONTENT.TICKETS.ALL_WORK_GROUPS' | translate }}" [multiple]="true" [(ngModel)]="filterRooms" (change)="onFilterChanged()"
                  class="filter-select">
                </ng-select>
              </div>
              <div class="col-2 mt-2">
                <ng-select [items]="creatorFilterList" name="creators" [clearSearchOnAdd]="true" [closeOnSelect]="false"
                  placeholder="{{ 'MAIN.CONTENT.TICKETS.ALL_CREATORS' | translate }}" [multiple]="true" [(ngModel)]="filterCreators" (change)="onFilterChanged()"
                  class="filter-select">
                </ng-select>
              </div>
              <div class="col-2 mt-2">
                <ng-select [items]="assigneeFilterList" name="assignees" [clearSearchOnAdd]="true" [closeOnSelect]="false"
                  placeholder="{{ 'MAIN.CONTENT.TICKETS.ALL_ASSIGNEES' | translate }}" [multiple]="true" [(ngModel)]="filterAssignees" (change)="onFilterChanged()"
                  class="filter-select">
                </ng-select>
              </div>
              <div class="col-2 mt-2">
                <input #filterDates="bsDaterangepicker" name="filterDates" [(ngModel)]="filterStartEnd" class="form-control datepicker-input" bsDaterangepicker
                  placeholder="{{ 'MAIN.CONTENT.TICKETS.CREATED_BETWEEN' | translate }}" [bsConfig]="{ rangeInputFormat: 'DD-MM-YYYY', containerClass: 'theme-blue', customTodayClass: 'datepicker-today' }"
                  onkeypress="return false;" (ngModelChange)="onFilterChanged()" style="cursor: default; height: 37px; font-size: 13px;">
              </div>
              <div class="col-3 mt-2">
                @if (tabIndex == 0) {
                  <ng-select [items]="ticketStatuses" name="statuses" bindLabel="name" bindValue="id" [clearSearchOnAdd]="true" [closeOnSelect]="false"
                    placeholder="{{ 'MAIN.CONTENT.TICKETS.ALL_STATUSES' | translate }}" [multiple]="true" [(ngModel)]="filterStatuses" (change)="onFilterChanged()"
                    class="filter-select">
                    <ng-template ng-label-tmp let-item="item">
                      {{ 'MAIN.CONTENT.TICKETS.STATUS_' + (item.id | uppercase) | translate }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ 'MAIN.CONTENT.TICKETS.STATUS_' + (item.id | uppercase) | translate }}
                    </ng-template>
                  </ng-select>
                }
              </div>
            </div>
          </div>
          <div class="user-table-header d-flex align-items-center">
            <div class="col-3 fs-14 font-weight-400 text-dark-grey d-flex align-items-center cursor-pointer"
              style="padding-left: 20px;" (click)="sortByTitle()">
              {{ 'MAIN.CONTENT.TICKETS.TICKET_TITLE' | translate }}
              @if (titleOrder == 'asc') {
                <img src="assets/img/down-icon-grey.svg" alt="" class="folder-icon">
              }
              @if (titleOrder == 'desc') {
                <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="folder-icon">
              }
              @if (!titleOrder) {
                <div class="p-relative ms-1 cursor-pointer" style="height:24px;">
                  <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="sort-icon up">
                  <img src="assets/img/down-icon-grey.svg" alt="" class="sort-icon down">
                </div>
              }
            </div>
            <div class="col-2 fs-14 font-weight-400 text-dark-grey d-flex align-items-center">
              {{ 'MAIN.CONTENT.TICKETS.WORK_GROUP' | translate }}
            </div>
            <div class="col-2 fs-14 font-weight-400 text-dark-grey d-flex align-items-center">
              {{ 'MAIN.CONTENT.TICKETS.CREATED_BY' | translate }}
            </div>
            <div class="col-2 fs-14 font-weight-400 text-dark-grey d-flex align-items-center cursor-pointer"
              (click)="sortByDate()">
              {{ 'MAIN.CONTENT.TICKETS.CREATED_ON' | translate }}
              @if (dateOrder == 'asc') {
                <img src="assets/img/down-icon-grey.svg" alt="" class="folder-icon">
              }
              @if (dateOrder == 'desc') {
                <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="folder-icon">
              }
              @if (!dateOrder) {
                <div class="p-relative ms-1 cursor-pointer" style="height:24px;">
                  <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="sort-icon up">
                  <img src="assets/img/down-icon-grey.svg" alt="" class="sort-icon down">
                </div>
              }
            </div>
            <div class="col-2 fs-14 font-weight-400 text-dark-grey d-flex align-items-center cursor-pointer">
              {{ 'MAIN.CONTENT.TICKETS.STATUS' | translate }}
            </div>
            <div class="col-1 fs-14 font-weight-400 text-dark-grey d-flex align-items-center"></div>
          </div>
          <div class="user-table-body">
            @if (!filteredTickets?.length) {
              <div class="empty-list fs-14 text-grey">{{ 'MAIN.CONTENT.TICKETS.NO_TICKETS' | translate }}</div>
            }
            <div class="workflow-table-body">
              @for (ticket of filteredTickets; track ticket; let i = $index) {
                <div class="workflow-card d-flex align-items-center cursor-pointer" (click)="selectTicket(i)">
                  <div class="col-3 fs-15 font-weight-700" style="padding-left: 20px;">{{ticket.title}}</div>
                  <div class="col-2 fs-14 font-weight-400 text-light-black">
                    {{ticket.room?.name || getRoomName(ticket.room_id)}}
                  </div>
                  <div class="col-2 fs-14 font-weight-400 text-light-black">
                    {{ticket.creator?.name || 'Unknown'}}
                  </div>
                  <div class="col-2 fs-14 font-weight-400 text-light-black">
                    {{formatDate(ticket.create_time)}}
                  </div>
                  <div class="col-2 d-flex justify-content-start ps-4 align-items-center" (click)="$event.stopPropagation()">
                    <div class="btn-group dropdown-wrapper-list status-wrapper-list ps-0 pe-0" dropdown style="width: 180px;border: none;">
                      <button type="button" class="btn btn-primary action-dropdown status-dropdown {{ticket.status}} p-0 text-start ps-2 hover-style fs-15" #toggleButton dropdownToggle>
                        <img src="assets/img/{{ticket.status}}.svg" alt="" class="status-dropdown-icon">
                        {{ 'MAIN.CONTENT.TICKETS.STATUS_' + (ticket.status | uppercase) | translate }}
                      </button>
                      <button id="button-split" type="button" class="btn dropdown-toggle dropdown-toggle-split status-toggle {{ticket.status}}" (click)="$event.stopPropagation(); toggleButton.click()"
                        aria-controls="dropdown-split">
                      </button>
                                    <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" style="max-height: 240px; 
                                    overflow-y: scroll; min-width: 130px;" aria-labelledby="dropdownMenuClickableInside">
                        @for (status of ticketStatuses; track status) {
                          <li role="menuitem">
                            <a class="dropdown-item fs-14 lato-regular" (click)="changeStatus(status.id, i)">
                              {{ 'MAIN.CONTENT.TICKETS.STATUS_' + (status.id | uppercase) | translate }}
                            </a>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                  <div class="col-1 d-flex justify-content-start ps-4 align-items-center" (click)="$event.stopPropagation()">
                    <div class="dropdown-wrapper" dropdown>
                      <a class="btn btn-default name-wrapper" id="dropdownMenuLink" dropdownToggle aria-controls="dropdown-basic">
                        <img src="assets/img/more.svg" alt="" height="20px">
                      </a>
                      <div #stepListStepOptions class="dropdown-menu" *dropdownMenu role="menu" aria-labelledby="dropdownMenuLink">
                        <div (click)="deleteTicket(ticket.id)">
                          <a class="dropdown-item folder-item">{{ 'MAIN.CONTENT.TICKETS.DELETE' | translate }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (selectedTicket || mode === 'create') {
    <div class="col-6 ticket-detail">
      <app-ticket-detail
        [(selectedTicket)]="selectedTicket"
        [mode]="mode"
        (selectedTicketChange)="selectedTicketChange($event)"
        (deletedTicket)="deleteTicket($event)"
        (ticketUpdated)="ticketUpdated($event)"
        (ticketCreated)="ticketCreated($event)">
      </app-ticket-detail>
    </div>
  }
</div>

<ng-template #loadingTemplate>
  <div class="loading-template">
    <div class="d-flex justify-content-center">
      <div class="loader loader-sm la-dark">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</ng-template>
